export default "__VITE_ASSET__B0Pnap7V__"